module.exports = __webpack_public_path__ + "img/bg.989ec484.jpg";